import "./page404.css";
export default (article) => {
	return `<div class="row page404__main justify-content-lg-center">
        <div class="col-lg-10">
            <h1 class="page404__header">${article.title}</h1>
            ${
							article.intro.length > 2
								? `<div class="page404__intro">${article.intro}</div>`
								: ""
						}
            <div class='p-0'>${article.mainImage}</div>
        </div>
        <div class="page404__content col-lg-7 p-lg-0">
            ${article.content}
        </div>
    </div>`;
};
